export default "__VITE_ASSET__wA03bBA___"